/*
 * Copyright Mimic Networks, Inc. 2026.
 */

export enum NodesPageTab {
  CONFIGURED = 'configured',
  PENDING = 'pending',
  ARCHIVED = 'archived',
  FLEETS = 'fleets',
}

export type NodesPageTabCounts = {
  configured: number;
  pending: number;
  archived: number;
  fleets: number;
};

export type NodesPageTabLoading = {
  configured: boolean;
  pending: boolean;
  archived: boolean;
  fleets: boolean;
};

export type NodesPageTabsProps = {
  activeTab: NodesPageTab;
  counts: NodesPageTabCounts;
  loading: NodesPageTabLoading;
  onTabChange?: (tab: NodesPageTab) => void;
};
